<template>
  <div class="card border-0 shadow-sm mt-3">
    <h5 class="mt-2 mb-2 ms-2">
      Observaciones de {{ p_tipo === 'M' ? 'Auditoría Médica' : 'Gestión Documental' }}
    </h5>
    <!-- Barra de acciones -->
    <div class="row g-2 align-items-center mb-3">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
          @click="getDataPaginaTodos(1)"
          title="Recargar todos los registros"
        >
          <span class="material-icons" style="font-size:16px">refresh</span> Todos
        </button>
      </div>
      <div
        class="col-auto ms-auto d-flex align-items-center gap-2"
        v-if="plaobss.length > 0"
      >
        <label class="form-label mb-0 small fw-bold">Mostrar</label>
        <select
          v-model.number="elementosPorPagina"
          class="form-select form-select-sm"
          style="width:75px"
          @change="aplicarPaginacion(1)"
        >
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <span class="small text-muted">registros</span>
      </div>
      <div class="col-auto" v-if="p_procesoAM || p_procesoGD">
        <button
          type="button"
          class="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
          @click="abrirModalCrear"
          title="Nuevo registro"
        >
          <span class="material-icons" style="font-size:16px">add_box</span>
          Registrar Observaciones
        </button>
      </div>
    </div>

    <!-- Tabla -->
    <div class="table-responsive" v-if="plaobss.length > 0">
      <table id="sampleTable" class="table table-hover table-bordered table-sm">
        <thead class="table-dark">
          <!-- Fila de encabezados -->
          <tr>
            <th></th>
            <th class="th-sort" @click="ordenarPor('observacionTipo')">
              Tipo <span>{{ iconOrden('observacionTipo') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('observacionDescripcion')">
              Observación estándar <span>{{ iconOrden('observacionDescripcion') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('descripcion')">
              Observación complementaria <span>{{ iconOrden('descripcion') }}</span>
            </th>
            <th v-if="p_procesoAM || p_procesoGD"></th>
          </tr>
          <!-- Fila de filtros -->
          <tr>
            <th></th>
            <th>
              <select
                v-model="filtroTipo"
                @change="aplicarPaginacion(1)"
                class="form-select form-select-sm"
              >
                <option value="">Todos</option>
                <option value="M">Auditoría Médica</option>
                <option value="D">Gestión Documental</option>
                <option value="C">Comunes</option>
              </select>
            </th>
            <th>
              <input
                v-model="filtroObsEstandar"
                @input="aplicarPaginacion(1)"
                class="form-control form-control-sm"
                placeholder="Filtrar..."
              />
            </th>
            <th>
              <input
                v-model="filtroDescripcion"
                @input="aplicarPaginacion(1)"
                class="form-control form-control-sm"
                placeholder="Filtrar..."
              />
            </th>
            <th v-if="p_procesoAM || p_procesoGD"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="plaobs in datosPaginados"
            :key="plaobs.idPlaObs"
            title="Doble clic para editar"
            @dblclick="abrirModalEditar(plaobs.idPlaObs, plaobs.observacionTipo)"
          >
            <td>
              <i
                class="material-icons"
                style="font-size: 16px; color: orangered; cursor: pointer"
                @click="abrirModalEditar(plaobs.idPlaObs, plaobs.observacionTipo)"
                title="Editar"
              >edit_square</i>
            </td>
            <td>
              <span class="badge" :class="badgeTipo(plaobs.observacionTipo)">
                {{ getTipoTexto(plaobs.observacionTipo) }}
              </span>
            </td>
            <td>{{ plaobs.observacionDescripcion }}</td>
            <td>{{ plaobs.descripcion }}</td>
            <td v-if="p_procesoAM || p_procesoGD">
              <i
                class="material-icons"
                style="font-size: 16px; color: red; cursor: pointer"
                @click="deletePlaObs(plaobs.idPlaObs, plaobs.observacionTipo)"
                title="Borrar"
              >delete</i>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary">
            <td :colspan="(p_procesoAM || p_procesoGD) ? 5 : 4" class="text-end fw-bold small">
              Mostrando {{ datosPaginados.length }} de {{ plaobsOrdenados.length }} registros
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Sin resultados -->
    <div v-if="sinResultados" class="alert alert-warning mt-3" role="alert">
      No se recuperaron registros.
    </div>

    <!-- Paginación -->
    <div
      class="d-flex justify-content-between align-items-center mt-3"
      v-if="plaobss.length > 0"
    >
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas() }} — {{ plaobsOrdenados.length }} registros
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(1)">«</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getPreviousPage">‹</a>
          </li>
          <li
            v-for="pagina in paginasVisibles"
            :key="pagina"
            class="page-item"
            :class="{ active: pagina === paginaActual, disabled: pagina === '...' }"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="pagina !== '...' && aplicarPaginacion(pagina)"
            >{{ pagina }}</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getNextPage">›</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(totalPaginas())">»</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      :aria-hidden="isModalOpen ? 'false' : 'true'"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons" style="font-size:24px; color:white">info</span>
            <h5 class="modal-title text-white" id="exampleModalLabel">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="cerrarModal"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- SELECTOR DE OBSERVACIÓN ESTÁNDAR -->
              <div class="obs-selector-card mb-3">
                <div class="obs-selector-header">
                  <span class="obs-selector-title">
                    <i class="material-icons obs-icon">search</i>
                    Observación Estándar
                  </span>
                  <span class="obs-count-badge">
                    {{ getTipoTexto(p_tipo) }} &nbsp;·&nbsp;
                    {{ observacionesFiltradas.length }} resultado{{ observacionesFiltradas.length !== 1 ? 's' : '' }}
                  </span>
                </div>
                <!-- Barra de búsqueda con debounce -->
                <div class="obs-search-bar">
                  <i class="material-icons obs-search-icon">manage_search</i>
                  <input
                    type="text"
                    class="obs-search-input"
                    v-model="filtroObservaciones"
                    placeholder="Buscar observación por descripción..."
                    @input="onFiltroInput"
                    @focus="mostrarLista = true"
                    autocomplete="off"
                  />
                  <button
                    v-if="filtroObservaciones"
                    type="button"
                    class="obs-clear-btn"
                    @click="limpiarFiltroObservaciones"
                    title="Limpiar"
                  >
                    <i class="material-icons" style="font-size:18px">close</i>
                  </button>
                </div>
                <!-- Observación seleccionada -->
                <div v-if="observacionSeleccionada" class="obs-selected-preview">
                  <i class="material-icons" style="font-size:16px;color:#0d6efd">check_circle</i>
                  <span class="obs-selected-badge">
                    {{ getTipoTexto(observacionSeleccionada.tipo) }}
                  </span>
                  <span class="obs-selected-text" v-html="observacionSeleccionada.descripcion"></span>
                </div>
                <!-- Lista de resultados -->
                <div
                  v-if="mostrarLista && observacionesFiltradas.length > 0"
                  class="obs-results-list"
                  ref="listaResultados"
                >
                  <div
                    v-for="obs in observacionesFiltradas"
                    :key="obs.idObservacion"
                    class="obs-result-item"
                    :class="{
                      'obs-result-item--selected': datoPlaObs.idObservacion === obs.idObservacion,
                      'obs-result-item--M': obs.tipo === 'M',
                      'obs-result-item--D': obs.tipo === 'D',
                      'obs-result-item--C': obs.tipo === 'C',
                    }"
                    @click="seleccionarObservacion(obs)"
                  >
                    <div class="obs-result-tipo">
                      <span :class="['obs-tipo-pill', `obs-tipo-pill--${obs.tipo}`]">
                        {{ obs.tipo }}
                      </span>
                    </div>
                    <div class="obs-result-desc">
                      <span v-html="resaltarTexto(obs.descripcion, filtroObservaciones)"></span>
                    </div>
                    <div v-if="datoPlaObs.idObservacion === obs.idObservacion" class="obs-result-check">
                      <i class="material-icons" style="font-size:18px;color:#0d6efd">check</i>
                    </div>
                  </div>
                </div>
                <!-- Sin resultados -->
                <div
                  v-else-if="mostrarLista && observacionesFiltradas.length === 0"
                  class="obs-empty"
                >
                  <i class="material-icons" style="font-size:32px;color:#adb5bd">search_off</i>
                  <p>No se encontraron observaciones para "<strong>{{ filtroObservaciones }}</strong>"</p>
                </div>
              </div>

              <!-- Observación Complementaria -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-11">
                    <label for="descripcion" class="form-label">Observación Complementaria</label>
                    <textarea
                      class="form-control"
                      id="descripcion"
                      v-model="datoPlaObs.descripcion"
                      style="text-transform: uppercase"
                    ></textarea>
                  </div>
                  <div class="buttons-container-mic">
                    <button
                      v-if="isDictatingCampo !== 'descripcion'"
                      @click="startDictation('descripcion')"
                      type="button"
                      class="btn btn-light"
                      title="Iniciar Dictado"
                    >
                      <span class="material-symbols-outlined" style="font-size: 40px; color: orangered; cursor: pointer">mic_off</span>
                    </button>
                    <button
                      v-else
                      @click="stopDictation"
                      type="button"
                      class="btn btn-light"
                      title="Finalizar Dictado"
                    >
                      <span class="material-symbols-outlined" style="font-size: 40px; color: green; cursor: pointer">mic</span>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Respuesta Estándar -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-12">
                    <label for="respuestaDescripcion" class="form-label">Respuesta Estándar</label>
                    <textarea
                      class="form-control"
                      id="respuestaDescripcion"
                      v-model="datoPlaObs.respuestaDescripcion"
                      style="text-transform: uppercase"
                      disabled
                    ></textarea>
                  </div>
                </div>
              </div>

              <!-- Respuesta Complementaria -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-12">
                    <label for="respuesta" class="form-label">Respuesta Complementaria</label>
                    <textarea
                      class="form-control"
                      id="respuesta"
                      v-model="datoPlaObs.respuesta"
                      style="text-transform: uppercase"
                      disabled
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarPlaObs"
              v-if="btnCrear && (p_procesoAM || p_procesoGD)"
              title="Guardar"
            >
              <i class="material-icons" style="font-size: 32px; color: blue; cursor: pointer">save</i>
              Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarPlaObs"
              v-if="btnEditar && (p_procesoAM || p_procesoGD)"
              title="Actualizar"
            >
              <i class="material-icons" style="font-size: 32px; color: blue; cursor: pointer">update</i>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import * as bootstrap from "bootstrap";
import SpeechDictation from "@/modules/microfono.js";
import Swal from "sweetalert2";

export default {
  props: {
    p_idPlanilla: { type: Number, required: true },
    p_tipo:       { type: String,  required: true },
    p_procesoAM:  { type: Boolean, required: true },
    p_procesoGD:  { type: Boolean, required: true },
  },

  data() {
    return {
      plaobss:            [],
      datoPlaObs:         {},
      datosPaginados:     [],
      sinResultados:      false,
      // ── Ordenamiento ──────────────────────────────────────
      campoOrden:         'idPlaObs',
      ascendente:         false,
      // ── Filtros de columna ─────────────────────────────────
      filtroTipo:         '',
      filtroObsEstandar:  '',
      filtroDescripcion:  '',
      // ── Filtro del modal ───────────────────────────────────
      filtroObservaciones: '',
      mostrarLista:        false,
      debounceTimer:       null,
      // ── UI ────────────────────────────────────────────────
      titulo:             '',
      btnCrear:           false,
      btnEditar:          false,
      elementosPorPagina: 10,
      paginaActual:       1,
      modalWindow:        true,
      observacions:       [],
      dictation:          new SpeechDictation(),
      isDictatingCampo:   null,
      idEmpresa:          0,
      isModalOpen:        false,
      modalInstance:      null,
    };
  },

  computed: {
    // ── Registros filtrados y ordenados ───────────────────────
    plaobsOrdenados() {
      const campo = this.campoOrden;

      let lista = this.plaobss.filter(p => {
        const tipo = this.filtroTipo
          ? (p.observacionTipo ?? '') === this.filtroTipo
          : true;
        const obs = this.filtroObsEstandar
          ? String(p.observacionDescripcion ?? '').toLowerCase().includes(this.filtroObsEstandar.toLowerCase())
          : true;
        const desc = this.filtroDescripcion
          ? String(p.descripcion ?? '').toLowerCase().includes(this.filtroDescripcion.toLowerCase())
          : true;
        return tipo && obs && desc;
      });

      return lista.sort((a, b) => {
        let va = a[campo] ?? '';
        let vb = b[campo] ?? '';
        if (campo === 'idPlaObs') {
          const na = parseInt(va, 10), nb = parseInt(vb, 10);
          if (!isNaN(na) && !isNaN(nb)) return this.ascendente ? na - nb : nb - na;
        }
        const cmp = String(va).localeCompare(String(vb), 'es');
        return this.ascendente ? cmp : -cmp;
      });
    },

    // ── Páginas visibles con puntos suspensivos ────────────────
    paginasVisibles() {
      const total  = this.totalPaginas();
      const actual = this.paginaActual;
      const delta  = 2;
      const rango  = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                        rango.unshift('...');
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push('...');
      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },

    // ── Observación seleccionada (preview modal) ───────────────
    observacionSeleccionada() {
      if (!this.datoPlaObs.idObservacion) return null;
      return this.observacions.find(o => o.idObservacion === this.datoPlaObs.idObservacion) || null;
    },

    // ── Lista filtrada del modal ───────────────────────────────
    observacionesFiltradas() {
      const texto = this.filtroObservaciones.toLowerCase().trim();
      return this.observacions.filter(obs => {
        return !texto ||
          (obs.descripcion?.toLowerCase() || '').includes(texto) ||
          this.getTipoTexto(obs.tipo).toLowerCase().includes(texto);
      });
    },
  },

  mounted() {
    this.idEmpresa = window.sessionStorage.getItem('idEmpresa');
    this.getDataPaginaTodos(this.paginaActual);
    this.fetchObservacions();
    const modalElement = document.getElementById('ventanaModal');
    if (modalElement) {
      this.modalInstance = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: false,
      });
    }
    document.addEventListener('click', this.onClickFuera);
  },

  beforeUnmount() {
    document.removeEventListener('click', this.onClickFuera);
  },

  methods: {
    // ── Helpers ───────────────────────────────────────────────
    getTipoTexto(tipo) {
      return { M: 'Auditoría Médica', D: 'Gestión Documental', C: 'Comunes' }[tipo] || tipo || 'Desconocido';
    },

    badgeTipo(tipo) {
      return {
        'bg-info text-dark':    tipo === 'M',
        'bg-warning text-dark': tipo === 'D',
        'bg-success':           tipo === 'C',
      };
    },

    resaltarTexto(texto, termino) {
      if (!texto) return '';
      const escapado = texto.replace(/[&<>"']/g, c =>
        ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
      );
      if (!termino || !termino.trim()) return escapado;
      const re = new RegExp(`(${termino.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
      return escapado.replace(re, '<mark class="obs-highlight">$1</mark>');
    },

    // ── Ordenamiento ──────────────────────────────────────────
    ordenarPor(campo) {
      if (this.campoOrden === campo) {
        this.ascendente = !this.ascendente;
      } else {
        this.campoOrden = campo;
        this.ascendente = true;
      }
      this.aplicarPaginacion(1);
    },

    iconOrden(campo) {
      if (this.campoOrden !== campo) return '⇅';
      return this.ascendente ? '↑' : '↓';
    },

    // ── Paginación ────────────────────────────────────────────
    totalPaginas() {
      return Math.max(1, Math.ceil(this.plaobsOrdenados.length / this.elementosPorPagina));
    },

    aplicarPaginacion(noPagina) {
      this.paginaActual   = noPagina;
      const ini           = (noPagina - 1) * this.elementosPorPagina;
      this.datosPaginados = this.plaobsOrdenados.slice(ini, ini + this.elementosPorPagina);
    },

    getPreviousPage() {
      if (this.paginaActual > 1) this.aplicarPaginacion(this.paginaActual - 1);
    },

    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) this.aplicarPaginacion(this.paginaActual + 1);
    },

    // ── Carga de datos ────────────────────────────────────────
    getDataPaginaTodos(noPagina) {
      this.sinResultados = false;
      api.get(`/vwplaobss/idplanilla/${this.p_idPlanilla}`).then(response => {
        this.plaobss       = Array.isArray(response.data) ? response.data.reverse() : [];
        this.aplicarPaginacion(noPagina);
        this.sinResultados = this.plaobss.length === 0;
      });
    },

    // ── Filtro modal: debounce ────────────────────────────────
    onFiltroInput() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => { this.mostrarLista = true; }, 250);
    },

    limpiarFiltroObservaciones() {
      this.filtroObservaciones = '';
      this.mostrarLista        = false;
    },

    seleccionarObservacion(obs) {
      this.datoPlaObs          = { ...this.datoPlaObs, idObservacion: obs.idObservacion };
      this.mostrarLista        = false;
      this.filtroObservaciones = obs.descripcion;
    },

    onClickFuera(event) {
      const card = this.$el.querySelector('.obs-selector-card');
      if (card && !card.contains(event.target)) this.mostrarLista = false;
    },

    // ── Dictado ───────────────────────────────────────────────
    startDictation(campo) {
      this.isDictatingCampo = campo;
      this.dictation.startDictation(transcript => {
        this.datoPlaObs[campo] = transcript;
      }, this.datoPlaObs[campo]);
    },

    stopDictation() {
      this.isDictatingCampo = null;
      this.dictation.stopDictation();
    },

    // ── Modal ─────────────────────────────────────────────────
    cerrarModal() {
      this.isModalOpen         = false;
      this.filtroObservaciones = '';
      this.mostrarLista        = false;
      if (this.modalInstance) this.modalInstance.hide();
    },

    abrirModalCrear() {
      this.modalWindow  = true;
      this.datoPlaObs   = {};
      this.titulo       = 'Crear';
      this.btnCrear     = true;
      this.btnEditar    = false;
      this.isModalOpen  = true;
      this.mostrarLista = true;
      if (this.modalInstance) this.modalInstance.show();
    },

    abrirModalEditar(idPlaObs, observacionTipo) {
      this.modalWindow = true;
      if (!idPlaObs) return;
      if (this.p_tipo !== observacionTipo) {
        Swal.fire({
          icon: 'warning',
          title: 'No se puede actualizar',
          text: `La observación fue registrada en ${this.getTipoTexto(observacionTipo)}`,
        });
        return;
      }
      api.get(`/vwplaobss/${idPlaObs}`).then(resp => {
        this.datoPlaObs  = resp.data;
        this.titulo      = 'Editar';
        this.btnCrear    = false;
        this.btnEditar   = true;
        this.isModalOpen = true;
        const obs = this.observacions.find(o => o.idObservacion === resp.data.idObservacion);
        if (obs) this.filtroObservaciones = obs.descripcion;
        if (this.modalInstance) this.modalInstance.show();
      });
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarPlaObs() {
      if (!this.datoPlaObs.idObservacion) {
        Swal.fire({ icon: 'warning', title: 'Ingrese una observación', text: 'Debe seleccionar una observación estándar' });
        return;
      }
      try {
        this.datoPlaObs.idPlanilla   = this.p_idPlanilla;
        this.datoPlaObs.idUsuarioReg = window.sessionStorage.getItem('idUsuario');
        await api.post('/plaobss', this.datoPlaObs);
        Swal.fire({ title: '¡Correcto!', text: 'Observación creada exitosamente.', icon: 'success', confirmButtonText: 'Aceptar' });
        this.getDataPaginaTodos(this.paginaActual);
        this.cerrarModal();
      } catch {
        Swal.fire({ title: 'Error', text: '¡Inténtelo de nuevo!', icon: 'error', confirmButtonText: 'Aceptar' });
        this.cerrarModal();
      }
    },

    async actualizarPlaObs() {
      if (!this.datoPlaObs.idObservacion) {
        Swal.fire({ icon: 'warning', title: 'Ingrese una observación', text: 'Debe seleccionar una observación estándar' });
        return;
      }
      try {
        this.datoPlaObs.idUsuarioAct = window.sessionStorage.getItem('idUsuario');
        await api.post('/plaobss', this.datoPlaObs);
        Swal.fire({ title: '¡Correcto!', text: 'Observación actualizada exitosamente.', icon: 'success', confirmButtonText: 'Aceptar' });
        this.getDataPaginaTodos(this.paginaActual);
        this.cerrarModal();
      } catch (error) {
        Swal.fire({ title: 'Error', text: 'Inténtelo de nuevo.', icon: 'error', confirmButtonText: 'Aceptar' });
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e => Swal.fire(String(e)));
        }
        this.cerrarModal();
      }
    },

    async deletePlaObs(idPlaObs, observacionTipo) {
      if (this.p_tipo !== observacionTipo) {
        Swal.fire({ icon: 'warning', title: 'No se puede eliminar', text: `La observación fue registrada en ${this.getTipoTexto(observacionTipo)}` });
        return;
      }
      try {
        await api.delete(`/plaobss/${idPlaObs}`);
        this.getDataPaginaTodos(this.paginaActual);
      } catch {
        Swal.fire({ title: 'Error', text: 'No se pudo eliminar.', icon: 'error', confirmButtonText: 'Aceptar' });
      }
    },

    fetchObservacions() {
      api
        .get(`/vwobservacions/idempresa-tipo-in/${this.idEmpresa}/${this.p_tipo}`)
        .then(response => { this.observacions = response.data; })
        .catch(error => { console.error('Error fetching observacions:', error); });
    },
  },
};
</script>

<style src="@/assets/css/microfono.css" scoped></style>

<style scoped>
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
.table-hover tbody tr {
  cursor: pointer;
}

/* ── Selector de observaciones ─────────────────────────── */
.obs-selector-card {
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 14px 16px;
  background: #f8f9fa;
  position: relative;
}
.obs-selector-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.obs-selector-title {
  font-weight: 600;
  font-size: 0.93rem;
  color: #343a40;
  display: flex;
  align-items: center;
  gap: 4px;
}
.obs-icon { font-size: 18px !important; color: #0d6efd; }
.obs-count-badge {
  font-size: 0.75rem;
  background: #0d6efd;
  color: #fff;
  border-radius: 20px;
  padding: 2px 10px;
  font-weight: 500;
}
.obs-search-bar {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 8px;
  padding: 0 10px;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.obs-search-bar:focus-within {
  border-color: #0d6efd;
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.15);
}
.obs-search-icon { font-size: 20px !important; color: #6c757d; margin-right: 6px; }
.obs-search-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 8px 0;
  font-size: 0.92rem;
  background: transparent;
}
.obs-clear-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #6c757d;
  display: flex;
  align-items: center;
  transition: color 0.15s;
}
.obs-clear-btn:hover { color: #dc3545; }
.obs-selected-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #e7f1ff;
  border: 1px solid #b6d4fe;
  border-radius: 8px;
  padding: 7px 12px;
  margin-top: 8px;
  font-size: 0.87rem;
  color: #084298;
}
.obs-selected-badge {
  font-size: 0.72rem;
  font-weight: 600;
  border-radius: 4px;
  padding: 2px 7px;
  background: #0d6efd;
  color: #fff;
  white-space: nowrap;
}
.obs-selected-text { color: #343a40; }
.obs-results-list {
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  margin-top: 8px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  scrollbar-width: thin;
  scrollbar-color: #adb5bd #f8f9fa;
}
.obs-results-list::-webkit-scrollbar { width: 6px; }
.obs-results-list::-webkit-scrollbar-thumb { background: #adb5bd; border-radius: 4px; }
.obs-result-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f1f3f5;
  transition: background 0.12s;
  font-size: 0.88rem;
}
.obs-result-item:last-child { border-bottom: none; }
.obs-result-item:hover { background: #f0f4ff; }
.obs-result-item--selected { background: #e7f1ff; }
.obs-result-item--M { border-left: 3px solid #0dcaf0; }
.obs-result-item--D { border-left: 3px solid #fd7e14; }
.obs-result-item--C { border-left: 3px solid #198754; }
.obs-result-tipo { flex-shrink: 0; }
.obs-tipo-pill {
  font-size: 0.7rem;
  font-weight: 700;
  border-radius: 4px;
  padding: 2px 6px;
  display: inline-block;
}
.obs-tipo-pill--M { background: #cff4fc; color: #055160; }
.obs-tipo-pill--D { background: #ffe5d0; color: #7c3c0c; }
.obs-tipo-pill--C { background: #d1e7dd; color: #0f5132; }
.obs-result-desc { flex: 1; line-height: 1.35; color: #212529; }
.obs-result-check { flex-shrink: 0; }
:deep(.obs-highlight) {
  background: #fff3cd;
  color: #664d03;
  border-radius: 2px;
  padding: 0 1px;
  font-weight: 600;
}
.obs-empty {
  text-align: center;
  padding: 20px;
  color: #6c757d;
  font-size: 0.88rem;
}
.obs-empty p { margin: 6px 0 0; }
</style>